/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdditionalProjectContact } from './AdditionalProjectContact';
import type { AiPromptsOverrides } from './AiPromptsOverrides';
import type { ClientContactSummary } from './ClientContactSummary';
import type { ClientStatus } from './ClientStatus';
import type { CreateProjectSettings } from './CreateProjectSettings';
import type { InternalUserSummary } from './InternalUserSummary';
import type { LanguageGroup } from './LanguageGroup';
import type { MachineTranslationSettings } from './MachineTranslationSettings';
import type { MachineTranslationSettingsOverrides } from './MachineTranslationSettingsOverrides';
import type { PowerBiReportDefinition } from './PowerBiReportDefinition';
import type { ProjectSubmissionMode } from './ProjectSubmissionMode';
import type { ReportDefinition } from './ReportDefinition';
import type { WorkflowOption } from './WorkflowOption';
export type ClientConfig = {
    id: string;
    disableSelfRegistration?: boolean;
    /**
     * App bundle ID
     */
    appBundleId?: string;
    enabledApplications?: Array<string>;
    allowedEmailDomains?: Array<string>;
    bccEmailNotifications?: Array<string>;
    xtrfServiceId?: number;
    logoKey?: string;
    bannerKey?: string;
    instructionalText?: string;
    createProjectToken?: string;
    signUpToken?: string;
    projectSubmissionMode?: ProjectSubmissionMode;
    projectSubmissionFooterMessage?: string;
    additionalProjectContacts?: Array<AdditionalProjectContact>;
    reports?: Array<ReportDefinition>;
    powerBiReports?: Array<PowerBiReportDefinition>;
    machineTranslationSettings?: MachineTranslationSettings;
    machineTranslationSettingsOverrides?: MachineTranslationSettingsOverrides;
    selectableWorkflows?: Array<WorkflowOption>;
    companyName?: string;
    status?: ClientStatus;
    xtrfBranchId?: number;
    lltsBranchId?: string;
    salesRepresentative?: InternalUserSummary;
    languageGroups?: Array<LanguageGroup>;
    isOrgManagementEnabled?: boolean;
    isMfaEnabled?: boolean;
    /**
     * Whether the chatbot help center is enabled for the client. When the property is not set, the system setting of the same name is used.
     *
     */
    isChatbotHelpCenterEnabled?: boolean;
    createProjectSettings?: CreateProjectSettings;
    /**
     * A list of external group names associated with a client
     */
    externalGroups?: Array<string>;
    /**
     * A map where application IDs serve as keys, with each key associated with an array of authorized user identifiers who have permission to access the corresponding application
     */
    appAccessAllowedListByAppId?: Record<string, Array<ClientContactSummary>>;
    /**
     * Determines if client contacts can see all projects and quotes or only their own
     */
    clientContactEntityViewScope?: ClientConfig.clientContactEntityViewScope;
    /**
     * A list of IP addresses or CIDR notations that are allowed to access the portal and client's project submission form
     */
    ipAddressWhitelist?: Array<string>;
    /**
     * Client-level overrides for AI prompts. Any field set will override the corresponding system-level prompt.
     */
    aiPromptsOverrides?: AiPromptsOverrides;
    /**
     * Determines if client contacts can skip the address fields on sign up
     */
    skipAddressOnSignUp?: boolean;
    /**
     * When true, the client's configuration is locked in the Admin UI and can only be changed by a Super Admin. This is a UI-only safeguard and is not enforced by the API.
     */
    isConfigLocked?: boolean;
};
export namespace ClientConfig {
    /**
     * Determines if client contacts can see all projects and quotes or only their own
     */
    export enum clientContactEntityViewScope {
        ALL = 'ALL',
        OWN = 'OWN',
    }
}

